<div class="content-wrapper table-full-bx groups-permissions">
    <div class="page-content recruiterpanel">
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox">
                    <div class="ibox-body">
                        <div class="flexbox pageHeading">
                            <div class="iboxcontent">
                                <h3 class="pb-1"> Groups & Permissions </h3>
                                <span> Manage your groups and permissions </span>
                            </div>
                            <div class="input-group-icon input-group-icon-left">
                                <div class="col-list-right">
                                    <form (ngSubmit)="searchFun()">
                                        <div class="form-group">
                                            <span class="input-icon input-icon-right font-16" (click)="searchFun()"><img src="assets/images/search.svg"></span>
                                            <input type="text" [(ngModel)]="search" autocomplete="off" class="form-control form-control-rounded form-control-solid search" name="search" id="key-search" placeholder="Search Id,Group,Description" />
                                            <span *ngIf="search" class="closeSearch" (click)="clearSearch()">&times;</span>
                                        </div>
                                    </form>
                                </div>
                                <div class="col-list-right">
                                    <a routerLink="/groups/add" class="commonBtn2"><img src="assets/images/ic_add_project.svg" class="ap" /> Add New Group </a>
                                </div>
                            </div>
                        </div>
                        <!-- end -->
                        <!-- Table -->
                        <div class="table-scroll table-wrapper user-top table-responsive">
                            <table id="example" class="table table-bordered " style="width: 100%;">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Groups</th>
                                        <th>Description</th>
                                        <th>Permission</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- 1 -->
                                    <tr *ngFor="let data of groupsData; let i=index;">
                                        <td><a href="javascript:void(0);">{{data?.id}}</a></td>
                                        <td><a href="javascript:void(0);">{{data?.groupName || "--"}}</a></td>
                                        <td><a href="javascript:void(0);" class="description">{{data?.groupDescription || "--"}}  </a></td>
                                        <td><a href="javascript:void(0);" class="jobid" data-toggle="modal" data-target="#manage_permissions"  (click)="openModal(managePermission,data?.id)"> Manage permissions </a></td>
                                        <td>
                                            <div ngbDropdown>
                                                <a class="icon" href="javascript:void(0);" data-toggle="dropdown" aria-expanded="false" id="dropdown_profile_area" ngbDropdownToggle><img src="assets/images/ic_three_dot.svg" />
                                                </a>
                                                <ul class="dropdown-menu" ngbDropdownMenu>
                                                    <li><a class="dropdown-item" href="javascript:void(0);" data-toggle="modal" data-target="#edit_permissions" (click)="openModal(editGroup,data?.id)"> Edit </a></li>
                                                    <li><a class="dropdown-item" [routerLink]="'manage-users/' + data?.id"> Manage users </a></li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="noDataFound" *ngIf="groupsData.length == 0">
                                <h2> No Records Found </h2>
                            </div>
                        </div>
                        <!-- end -->
                        <!--  pagination  -->
                        <div class="col-sm-12 p-0" *ngIf="groupsData.length > 9">
                            <ul class="pagination ">
                                <pagination-controls id="pagination" (pageChange)="pageChanged($event)" previousText="&#60;" nextText="Next" firstText="&#62;" lastText="Last"></pagination-controls> 
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End -->

<!-- Modal manage_permissions -->
<ng-template #managePermission>
    <div class="modal-body permissions-popup">
        <div class="add-permissions">
            <h5 class="modal-title text-left"> Manage Permissions for : Recruiter </h5>
            <div class="jobswrap" *ngFor="let access of accessList; let i=index">
                <h6 class="sub_title"> {{access?.name}} </h6>
                <div class="row">
                    <div class="col-lg-6" *ngFor="let acc of access?.placeholder; let j = index">
                        <div class="checkboxWrap" (click)="clickEvent(i,j)">
                            <input type="checkbox" 
                            [checked]="acc?.permission == 1 ? true : false"
                             /> 
                            <label for="jobs1">{{acc.title}}</label>
                        </div>
                    </div>
                 </div>
            </div>
        </div>
        <div class="btnwrap">
            <input value="Cancel" name="" class="common-btn unfill" type="submit" data-dismiss="modal" (click)="closeModal()"/>
            <input value="Save" name="" class="common-btn" type="submit" (click)="submitGroupPermission()"/>
        </div>
      </div>
</ng-template>


<!-- Modal edit_permissions -->
<ng-template #editGroup>
    <div class="modal-body edit-permissions-popup">
        <h5 class="modal-title text-left"> Edit Group </h5>
        <p class="p-heading"> Here you can edit group </p>
        <form [formGroup]="groupForm">
            <div class="form-group">
                <label> Name of the group </label>
                <input type="text" class="form-control" name="" formControlName="groupName" placeholder="Recruiter" appCapitalizeFirst>
                <div class="text-danger" *ngIf="groupForm.controls['groupName'].hasError('required') && showError">
                    *Please enter group name.
                </div>
                <div class="text-danger" *ngIf="groupForm.controls['groupName'].hasError('minlength') && showError">
                    *Minimum 3 characters required.
                </div>
                <div class="text-danger" *ngIf="groupForm.controls['groupName'].hasError('maxlength') && showError">
                    *Maximum 30 characters required.
                </div>
                <div class="text-danger" 
                    *ngIf="!groupForm.controls['groupName'].hasError('required') && 
                        !groupForm.controls['groupName'].hasError('minlength') && 
                        !groupForm.controls['groupName'].hasError('maxlength') && 
                        groupForm.controls['groupName'].hasError('cannotContainSpace') && showError">
                    *Invalid characters.
                </div>
            </div>
            <div class="form-group">
                <label> Group’s description </label>
                <textarea class="form-control" type="text" formControlName="groupDescription" maxlength="250" appCapitalizeFirst placeholder="This article is about ground-warfare militaries. For the large military."></textarea>
                <span class="input-count">{{groupForm?.value?.groupDescription?.length}}/250</span>    
                <div class="text-danger" *ngIf="groupForm.controls['groupDescription'].hasError('required') && showError">
                    *Please enter group description.
                </div>
                <div class="text-danger" *ngIf="groupForm.controls['groupDescription'].hasError('minlength') && showError">
                    *Minimum 3 characters required.
                </div>
                <div class="text-danger" *ngIf="groupForm.controls['groupDescription'].hasError('maxlength') && showError">
                    *Maximum 250 characters required.
                </div>
                <div class="text-danger" 
                    *ngIf="!groupForm.controls['groupDescription'].hasError('required') && 
                    !groupForm.controls['groupDescription'].hasError('minlength') && 
                    !groupForm.controls['groupDescription'].hasError('maxlength') && 
                    groupForm.controls['groupDescription'].hasError('cannotContainSpace') && showError">
                    *Invalid characters.
                </div>
            </div>
        </form>
        <div class="btnwrap">
            <input value="Cancel" name="" class="common-btn unfill" type="submit" data-dismiss="modal" (click)="closeModal()"/>
            <input value="Save" name="" class="common-btn" type="submit" (click)="submitGroup()"/>
        </div>
      </div>
</ng-template>